import Iva from "../../model/Iva.js";
import { EnergyCosts } from "../../model/Costs.js";

class Light {
    
    perdite = 1.104;
    PD = 0.01388; 
    DISPbt = -13.983;
    trasporto = {
        prezzo: 0,
        canone: 0,
        prezzoPotenza: 0
    };
    oneri = {
        prezzo: 0,
        canone: 0
    };
    Iva = Iva;
    f = 0;                      //- prezzo materia prima ---
    f1 = 0;                     //- prezzo materia prima ---
    f2 = 0;                 //- prezzo materia prima ---
    PCV = 0;                    //- custom EGL PCV --- scontocerto 120 --- sceltasicura quella dell'autorità
    PPE = 0;                     //- mercato libero residenziale
    
    constructor(){}

    setProduct( product ){
        console.log( 'Light setProduct', product, EnergyCosts );
        //- Products variables ---
        this.f = product.f;
        this.f1 = product.f1;
        this.f2 = product.f2;
        this.PCV = product.PCV;

    //- Power variables ---
        this.perdite = EnergyCosts.perdite;
        this.PD = EnergyCosts.PD;
        this.DISPbt = EnergyCosts.DISPbt;
        this.PPE = ( product.PPE ) ? EnergyCosts.PPE : 0;
        this.oneri = EnergyCosts.oneri;
        this.trasporto = EnergyCosts.trasporto;
    }

    expenditure( consumptionF1, consumptionF2, product, potenza, resident, moltiplicator ){
        console.log( 'Light expenditure', consumptionF1, consumptionF2, product, potenza, resident );

        this.setProduct( product );

        let consumption = parseInt(consumptionF1) + parseInt(consumptionF2);

        //- Materia energia ---
            let materia = this.prezzoMateriaEnergia( consumption, consumptionF1, consumptionF2, moltiplicator );
        //- Traposto ---
            let trasporto = this.prezzoTrasporto( consumption, potenza );
        //- Oneri ---
            let oneri = this.prezzoOneri( consumption, resident );

        console.log( 'Light expenditure return materia, trasporto, oneri, materia +  trasporto + oneri' );
        console.log( 'Light expenditure return', materia, trasporto, oneri, materia +  trasporto + oneri );
        return materia +  trasporto + oneri;
    }
    
    prezzoMateriaEnergia( consumption, consumptionF1, consumptionF2, moltiplicator ){
        console.log( 'Light prezzoMateriaEnergia: ( this.f * consumption * this.perdite + this.PD * consumption + this.PCV + this.DISPbt + this.PPE) * this.Iva.ridotta' );
        console.log( 'Light prezzoMateriaEnergia: (', this.f * moltiplicator, '*' , consumption, '*', this.perdite, '+', this.PD, '*', consumption, '+', this.PCV, '+', this.DISPbt, '+', this.PPE, ') * ', this.Iva.ridotta );

        if ( consumptionF2 <= 0 ){
            console.log( 'Light prezzoMateriaEnergia MONO SI', consumptionF2 );
            return ( this.f * moltiplicator * consumption * this.perdite + this.PD * consumption + this.PCV + this.DISPbt + this.PPE ) * this.Iva.ridotta;
        } else {
            console.log( 'Light prezzoMateriaEnergia MONO NO', consumptionF2 );
            return ( this.f1 * moltiplicator * consumptionF1 * this.perdite + this.f2 * consumptionF2 * this.perdite + this.PD * consumption + this.PCV + this.DISPbt + this.PPE ) * this.Iva.ridotta;
        }
    }

    prezzoTrasporto( consumption, potenza ){
        console.log( 'Light prezzoTrasporto: this.trasporto.prezzo * consumption + this.trasporto.canone + this.trasporto.prezzoPotenza * potenza ) * this.Iva.ridotta' );
        console.log( 'Light prezzoTrasporto: (', this.trasporto.prezzo, '*' , consumption, '+', this.trasporto.canone, '+', this.trasporto.prezzoPotenza, '*', potenza, ') *', this.Iva.ridotta );

        return ( this.trasporto.prezzo * consumption + this.trasporto.canone + this.trasporto.prezzoPotenza * potenza ) * this.Iva.ridotta;
    }

    prezzoOneri( consumption, resident ){
        console.log( 'Light prezzoOneri: ( this.oneri.prezzo * consumption ) * this.Iva.ridotta' );
        console.log( 'Light prezzoOneri: (', this.oneri.prezzo, '*' , consumption, ') * ', this.Iva.ridotta );

        // console.log( 'Light prezzoOneri', consumption, resident );
        // console.log( 'Light prezzoOneri', this.oneri.prezzo, this.oneri.canone );
        // console.log( 'Light prezzoOneri return', ( this.oneri.prezzo * consumption + ( resident ? 0 : this.oneri.canone ) ) * this.Iva.ridotta );

        return ( this.oneri.prezzo * consumption + ( resident ? 0 : this.oneri.canone ) ) * this.Iva.ridotta;
    }

}
export default new Light();